// Русский язык использует исходные ключи как тексты.
// Карта оставлена пустой, чтобы t(key) возвращал оригинальный ключ.
const ru = {};

export default ru;




